import { render, staticRenderFns } from "./TeamsSheetEdit.vue?vue&type=template&id=096d1c8e&scoped=true&"
import script from "./TeamsSheetEdit.vue?vue&type=script&lang=ts&"
export * from "./TeamsSheetEdit.vue?vue&type=script&lang=ts&"
import style0 from "./TeamsSheetEdit.vue?vue&type=style&index=0&id=096d1c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d1c8e",
  null
  
)

export default component.exports